export default __webpack_public_path__ + "static/media/notificationLg.5ccf1a37.svg";